var FolderDialogForCreateManager_1, FolderDialogForEditManager_1, MoveFolderDialogManager_1;
var _a, _b, _c;
import { __decorate, __metadata, __param } from "tslib";
import ptDialogAutoMounterManager from '@/services/PtDialogAutoMounterManager';
import { rvTrack } from 'track';
import { DetailServiceSymbol } from '@/services/DetailService';
import { Toast } from 'patsnap-biz';
import _ from 'lodash';
import { router } from '@/routers';
import { provide, inject, injectService } from '@/inversify.config';
import { i18nSymbol } from '@/i18n';
import { SpaceService } from '@/domains/detail/space/types/space-service.interface';
export const FolderDialogForCreateManagerSymbol = Symbol.for('FolderDialogForCreateManager');
let FolderDialogForCreateManager = FolderDialogForCreateManager_1 = class FolderDialogForCreateManager {
    static Dialog() {
        return import('@/presentation/components/folders/FolderDialogForCreate.vue');
    }
    constructor(detailService, spaceService) {
        this.detailService = detailService;
        this.spaceService = spaceService;
        ptDialogAutoMounterManager.register(FolderDialogForCreateManager_1.Dialog);
    }
    open(params) {
        ptDialogAutoMounterManager.update(FolderDialogForCreateManager_1.Dialog, {
            spaceId: this.spaceService.spaceInfo.space_id,
            // @ts-ignore
            isSample: !!this.spaceService.spaceInfo.is_sample,
            onActionHandler: this.onAddFolder.bind(this),
            onCloseHandler: this.close.bind(this),
            ...params,
        });
        ptDialogAutoMounterManager.toggleOpenState(FolderDialogForCreateManager_1.Dialog, true);
        rvTrack('Add Folder', {
            source: window.location.pathname + window.location.search,
        });
    }
    close() {
        ptDialogAutoMounterManager.toggleOpenState(FolderDialogForCreateManager_1.Dialog, false);
    }
    onAddFolder(folder) {
        this.detailService.addFolder(folder);
        const i18n = injectService(i18nSymbol);
        Toast({
            type: 'success',
            message: i18n.t('folder.labels.addOk'),
            showClose: true,
        });
    }
};
FolderDialogForCreateManager = FolderDialogForCreateManager_1 = __decorate([
    provide(FolderDialogForCreateManagerSymbol),
    __param(0, inject(DetailServiceSymbol)),
    __param(1, inject(SpaceService)),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof SpaceService !== "undefined" && SpaceService) === "function" ? _a : Object])
], FolderDialogForCreateManager);
export { FolderDialogForCreateManager };
export const FolderDialogForEditManagerSymbol = Symbol.for('FolderDialogForEditManager');
let FolderDialogForEditManager = FolderDialogForEditManager_1 = class FolderDialogForEditManager {
    constructor(detailService, spaceService) {
        this.detailService = detailService;
        this.spaceService = spaceService;
        ptDialogAutoMounterManager.register(FolderDialogForEditManager_1.Dialog);
    }
    static Dialog() {
        return import('@/presentation/components/folders/FolderDialogForEdit.vue');
    }
    open(folder, opt = {}) {
        ptDialogAutoMounterManager.update(FolderDialogForEditManager_1.Dialog, {
            spaceId: this.spaceService.spaceInfo.space_id,
            mode: 'edit',
            onActionHandler: opt.onActionHandler ? opt.onActionHandler : this.onEditFolder.bind(this),
            onCloseHandler: this.close.bind(this),
            folder,
        });
        ptDialogAutoMounterManager.toggleOpenState(FolderDialogForEditManager_1.Dialog, true);
    }
    close() {
        ptDialogAutoMounterManager.toggleOpenState(FolderDialogForEditManager_1.Dialog, false);
    }
    onEditFolder(folder) {
        this.detailService.editFolder(folder);
        const i18n = injectService(i18nSymbol);
        Toast({
            type: 'success',
            message: i18n.t('folder.labels.editOk'),
            showClose: true,
        });
    }
};
FolderDialogForEditManager = FolderDialogForEditManager_1 = __decorate([
    provide(FolderDialogForEditManagerSymbol),
    __param(0, inject(DetailServiceSymbol)),
    __param(1, inject(SpaceService)),
    __metadata("design:paramtypes", [Object, typeof (_b = typeof SpaceService !== "undefined" && SpaceService) === "function" ? _b : Object])
], FolderDialogForEditManager);
export { FolderDialogForEditManager };
export const MoveFolderDialogManagerSymbol = Symbol.for('MoveFolderDialogManager');
let MoveFolderDialogManager = MoveFolderDialogManager_1 = class MoveFolderDialogManager {
    static MoveFolderDialog() {
        return import('@/presentation/components/folders/MoveFolderDialog.vue');
    }
    constructor(detailService, spaceService) {
        this.detailService = detailService;
        this.spaceService = spaceService;
        ptDialogAutoMounterManager.register(MoveFolderDialogManager_1.MoveFolderDialog);
    }
    open(params = { type: 'move', source: [] }) {
        ptDialogAutoMounterManager.update(MoveFolderDialogManager_1.MoveFolderDialog, {
            mode: params.type,
            source: params.source,
            show: true,
            onActionHandler: params.onActionHandler || this.onMoveFolder.bind(this),
            onCloseHandler: this.close.bind(this),
        }, {
            'update:show': (val) => {
                ptDialogAutoMounterManager.toggleOpenState(MoveFolderDialogManager_1.MoveFolderDialog, val);
            },
        });
        ptDialogAutoMounterManager.toggleOpenState(MoveFolderDialogManager_1.MoveFolderDialog, true);
    }
    close() {
        ptDialogAutoMounterManager.toggleOpenState(MoveFolderDialogManager_1.MoveFolderDialog, false);
    }
    onMoveFolder(mode, source, targetFolder) {
        // 单个文件夹
        const folder = source[0];
        // 重新加载 FolderTree
        this.detailService.refetchFolders()
            .then((folders) => {
            // 无文件夹 显示空白
            if (!_.find(folders, { parent_id: '-root' })) {
                router.push({ name: 'detailPatentRoot', query: { spaceId: this.spaceService.spaceInfo.space_id } });
                return;
            }
            // 当前文件夹被删除
            if (router.currentRoute.query.folderId === folder.folder_id ||
                this.detailService.isInFolder(folder, targetFolder)) {
                if (mode === 'copy')
                    return;
                // 跳转到删除后的第一个文件夹
                const firstFolder = _.find(folders, { parent_id: '-root' }) || _.head(folders);
                router.push({
                    ...router.currentRoute,
                    query: {
                        ...router.currentRoute.query,
                        folderId: firstFolder.folder_id,
                        page: '1',
                    },
                });
            }
        })
            .catch((err) => {
            if (err._error_msg) {
                Toast({
                    type: 'error',
                    message: err._error_msg,
                    showClose: true,
                });
            }
        });
    }
};
MoveFolderDialogManager = MoveFolderDialogManager_1 = __decorate([
    provide(MoveFolderDialogManagerSymbol),
    __param(0, inject(DetailServiceSymbol)),
    __param(1, inject(SpaceService)),
    __metadata("design:paramtypes", [Object, typeof (_c = typeof SpaceService !== "undefined" && SpaceService) === "function" ? _c : Object])
], MoveFolderDialogManager);
export { MoveFolderDialogManager };
